import { API_BASE_URL } from '../../../api';
import React, { useState, useContext } from 'react';
import './login.style.scss';
import lgoLogo from '../../../assets/SVG/LGO.svg';
import { useNavigate } from "react-router-dom";
import { jwtDecode } from 'jwt-decode';
import { AccountContext } from '../../../Contexts/main.context';

const Login = ({ onLogin }) => {
     const [email, setEmail] = useState('');
     const [password, setPassword] = useState('');
     const [error, setError] = useState(null);
     const navigate = useNavigate();
     const { updateMyAccount, updateReturnToLastLink,updateOriginalID } = useContext(AccountContext);

     const handleSubmit = async (e) => {
          e.preventDefault();

          if (!email || !password) {
               setError("Please fill in both fields.");
               return;
          }
          updateReturnToLastLink(null);
          try {
               const response = await fetch(API_BASE_URL + 'login.php', {
                    method: "POST",
                    headers: {
                         "Content-Type": "application/json"
                    },
                    body: JSON.stringify({ email, password })
               });
               const data = await response.json(); // 👈 parse the actual body
               if (data.status === 'success') {
                    localStorage.setItem('LGOUser', data.token);
                    const token = data.token;
                    if (token && typeof token === 'string') {
                         const decoded = jwtDecode(token);
                         updateMyAccount(decoded);
                         if (decoded.security === 'Client') {
                              updateOriginalID(decoded.clientAccount);
                              navigate('/clientDashboard');
                              return
                         }
                    }
                    navigate('/dashboard');
               } else {
                    setError("Login failed. Please check your credentials.");
               }

          } catch (err) {
               console.error(err);
               setError("An error occurred. Please try again later.");
          }
     };


     const forgotMyPass = () => {
          alert('Forgot Password coming online shortly')
     }


     return (
          <div className="login-container bg-dark">
               <div className="col-24 offset-8 d-flex gap-3 align-items-center" style={{ minHeight: "250px" }}>
                    <div className="col-18 text-end pe-3">
                         <img src={lgoLogo} height="80px" alt="" />
                    </div>
                    <div className="col-24 border-start border-1 border-light ">
                         <form className="login-form" onSubmit={handleSubmit}>
                              {error && <div className="alert alert-danger">{error}</div>}
                              <div className="form-group mb-2">
                                   <div className="h3 text-light text-center">Log In</div>
                              </div>
                              <div className="form-group mb-3">
                                   <label className='text-light'>Email</label>
                                   <input
                                        type="text"
                                        className="form-control"
                                        value={email}
                                        onChange={(e) => setEmail(e.target.value)}
                                        autoComplete="email"
                                   />
                              </div>

                              <div className="form-group mb-4">
                                   <label className='text-light'>Password</label>
                                   <input
                                        type="password"
                                        className="form-control"
                                        value={password}
                                        onChange={(e) => setPassword(e.target.value)}
                                        autoComplete="current-password"
                                   />
                              </div>

                              <button type="submit" className="btn btn-warning w-100">
                                   Log In
                              </button>
                              <div className="forgot" style={{ cursor: "pointer" }} onClick={() => forgotMyPass()}>Forgot Your Password?</div>
                         </form>
                    </div>
               </div>
          </div>
     );
};

export default Login;
